(function () {
	'use strict';

	angular.module('app.core')
		.directive('metricChart', metricChart);

	function metricChart($window, $filter, $rootScope, $timeout,
			currencyFormatService, numberFormatService, percentageFormatService,
			$translate, fullPageChart, chartService, leanFilterService,
			getJsonData, URLS, slideInModalService, metricRoundingService) {
		var services = {
			'currency': currencyFormatService,
			'float': numberFormatService,
			'percentage': percentageFormatService
		};

		return {
			restrict: 'A',
			//chartId passed in from controller via HTML
			scope: {
				chartId: '@chartId',
				valueStream: '@valueStream',
				isEmbedded: '@isEmbedded',
				disableColorCodingVsTarget: '=?',
				hideLegend: '=?',
				tooManyCategories: '=?'
			},
			link: function (scope, elem, attrs) {
				var chartKey = scope.chartId;
				var vstreamNdx = scope.valueStream;
				var eventName = 'event:metricCtrl:getChart';
				var embedded = false;
				if (typeof vstreamNdx !== 'undefined' && (vstreamNdx || vstreamNdx == '' || vstreamNdx === 0 || scope.isEmbedded)) {
					embedded = true;
					eventName = 'event:metricCtrl' + chartKey + '-' + vstreamNdx + ':getChart';
				}
				var metricConfig = {};
				var chartData = {};
				var currencySymbol;
				var yAxisFieldLabel = '';
				var yAxisFieldLabelTwo = '';
				var xAxisField = 'date';
				var xAxisFieldLabel = '';
				var actualValues = [];
				var targetValues = [];
				var dataTargetsArray = {};
				var dataMonthArray = {};
				var fmtService = {};
				var fmtServiceTwo = {};
				var trendLineList = [];
				var isComboChart = false;
				var chart;
				var opened = false;
				var w = angular.element($window);
				var width = Math.max(w.width(), window.innerWidth);
				scope.height = window.innerHeight;
				scope.paddingTop = 4;
				scope.paddingBottom = 0;
				elem[0].id = elem[0].id + scope.$id;
				var scopeAccessor = embedded ? scope.$parent : scope.$parent.$parent;
				var widgetHeight = 250;
				var slideshow = false;
				var print = false;

				if (jQuery(elem[0]).parents('.slideshowWidget').length) {
					widgetHeight = scope.height - 130 - 95;
					scope.paddingLt = 78;
					scope.paddingRt = 22;
					scope.paddingTop = 8;
					scope.paddingBottom = 12;
					scope.rectOneX = -30;
					scope.rectTwoX = 20;
					scope.rectSide = 14;
					slideshow = true;
				} else if (jQuery(elem[0]).parents('.printable-widget').length) {
					if (scope.height - 400 > 400) {
						widgetHeight = 400;
					} else {
						widgetHeight = scope.height - 400;
					}
					scope.width = undefined;
					scope.paddingLt = 80;
					scope.paddingRt = 80;
					scope.paddingTop = 20;
					scope.paddingBottom = 10;
					print = true;
				} else if (width > 992) {
					scope.paddingLt = 59;
					scope.paddingRt = 59;
					scope.rectOneX = -30;
					scope.rectTwoX = 20;
					scope.rectSide = 10;
				} else if (width >= 768) {
					scope.paddingLt = 48;
					scope.paddingRt = 48;
					scope.rectOneX = -27.5;
					scope.rectTwoX = 17.5;
					scope.rectSide = 8;
				} else {
					scope.paddingLt = 36;
					scope.paddingRt = 36;
					scope.rectOneX = -23;
					scope.rectTwoX = 16;
					scope.rectSide = 6;
				}

				setWidgetPaddings();

				scope.getWindowDimensions2 = function () {
					return {
						'w': Math.max(w.width(), window.innerWidth),
						'h': window.innerHeight
					};
				};

				scope.$watch(scope.getWindowDimensions2, function (newValue, oldValue) {
					scope.windowWidth2 = newValue.w;
					scope.height = newValue.h;
					var currentPaddingLeft = scope.paddingLt;

					if (slideshow) {
						widgetHeight = scope.height - 130 - 95;
						scope.rectOneX = -20;
						scope.rectTwoX = 20;
						scope.rectSide = 14;
					} else if (print) {
						scope.rectOneX = -20;
						scope.rectTwoX = 10;
						scope.rectSide = 10;
					} else if (scope.windowWidth2 >= 992) {
						scope.paddingLt = 59;
						scope.paddingRt = 59;
						scope.rectOneX = -20;
						scope.rectTwoX = 10;
						scope.rectSide = 10;
					} else if (scope.windowWidth2 >= 768) {
						scope.paddingLt = 48;
						scope.paddingRt = 48;
						scope.rectOneX = -17.5;
						scope.rectTwoX = 8;
						scope.rectSide = 8;
					} else {
						scope.paddingLt = 36;
						scope.paddingRt = 36;
						scope.rectOneX = -16;
						scope.rectTwoX = 6;
						scope.rectSide = 6;
					}

					setWidgetPaddings();

					if (!print && (currentPaddingLeft !== scope.paddingLt || newValue.h !== oldValue.h)) {
						generateChart();
						if (isComboChart) {
							paintRect('#0000FF', '#7cc4fa');
						}
					}
				}, true);

				w.bind('resize', function () {
					scope.$apply();
				});

				function setWidgetPaddings() {
					if (!globalConfig.browser.locale.startsWith('en')) {
						scope.paddingLt = scope.paddingLt + 15;
					}
				}

				function tooltipFormat(d, defaultTitleFormat, defaultValueFormat, color) {
					var $$ = this;
					var config = $$.config;
					var CLASS = $$.CLASS;
					var titleFormat = config.tooltip_format_title || defaultTitleFormat;
					var nameFormat = config.tooltip_format_name || function (name) {
						return name;
					};
					var valueFormat = config.tooltip_format_value || defaultValueFormat;
					var text, i, title, value, valueTwo, name, bgcolor;

					var targetValue;
					for (i = 0; i < d.length; i++) {
						if (d[i].id === 'target') {
							targetValue = d[i].value;
							break;
						}
					}

					for (i = 0; i < d.length; i++) {
						if (!d[i] || !(d[i].value || d[i].value === 0)) {
							continue;
						}
						if (!text) {
							title = titleFormat ? titleFormat(d[i].x) : d[i].x;
							text = '<table class=\'' + CLASS.tooltip + '\'>';
							if (title || title === 0) {
								text += '<tr><th colspan=\'2\'>' + title + '</th></tr>';
							}
						}

						value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
						if (isComboChart) {
							valueTwo = valueFormat(d[i].valueTwo, d[i].ratio, d[i].id, d[i].index);
						}
						if (value !== undefined || valueTwo !== undefined) {
							name = d[i].name;

							var colorCode = color(d[i].id);

							if (d[i] === 'trend' || d[i].id === 'trend') {
								colorCode = '#C12283';
							} else if (!metricConfig.isCategorizedTwo &&
								((typeof d[i] === 'string' && d[i].indexOf('categoryTwo_') === 0) ||
									(d[i].id && d[i].id.indexOf('categoryTwo_') === 0 &&
										(!metricConfig.targetsVisible ||
											metricConfig.targetsVisible !== 'y2')))) {
								colorCode = '#7cc4fa';
							} else if (!metricConfig.isCategorized &&
								(isComboChart && (typeof d[i] === 'string' && d[i].indexOf('category_') === 0) ||
									(isComboChart && d[i].id && d[i].id.indexOf('category_') === 0 &&
										(!metricConfig.targetsVisible ||
											metricConfig.targetsVisible !== 'y')))) {
								colorCode = '#005FA5';
							} else if (!metricConfig.isCategorized &&
								((typeof d[i] === 'string' && d[i].indexOf('category_') === 0) ||
									(d[i].id && d[i].id.indexOf('category_') === 0 &&
										(!metricConfig.targetsVisible ||
											metricConfig.targetsVisible === 'y')))) {
								// don't override default color for categorized metrics
								if (targetValue === null || targetValue === undefined ||
									scope.disableColorCodingVsTarget) {
									colorCode = '#005FA5';
								} else {
									colorCode = getColorCode(d[i].value, targetValue, colorCode, fmtService);
								}
							} else if (!metricConfig.isCategorizedTwo && d[i].id &&
								d[i].id.indexOf('categoryTwo_') === 0 &&
								(!metricConfig.targetsVisible || metricConfig.targetsVisible === 'y2')) {
								// don't override default color for categorized metrics
								if (targetValue === null || targetValue === undefined ||
									scope.disableColorCodingVsTarget) {
									colorCode = '#7cc4fa';
								} else {
									colorCode = getColorCode(d[i].value, targetValue, colorCode, fmtService);
								}
							}

							text += '<tr class="' + CLASS.tooltipName + '-' + d[i].id + '">';
							text += '<td class="name"><span style="background-color:' + colorCode + '"></span>' + name + '</td>';
							text += '<td class="value">' + value + '</td>';
							text += '</tr>';
						}
					}
					return text + '</table>';
				}

				function getColorCode(value, target, defaultColor, fmtService) {
					// account for small discrepancies like floating point errors
					var absTarget = Math.abs(target);
					var tinyFractionOfTarget = 0.00001;
					if (absTarget < 1) {
						tinyFractionOfTarget *= absTarget;
					}
					var colorCode = defaultColor;
					if (value || value === 0) {
						if (metricConfig.goalType === 'Below') {
							if (value <= target + tinyFractionOfTarget) {
								colorCode = '#37C074'; //Green
							} else if (value <= target + absTarget * 0.1) {
								colorCode = '#FFE349'; //Yellow
							} else {
								colorCode = '#F42F2F'; //Red
							}
						} else {
							if (value >= target - tinyFractionOfTarget) {
								colorCode = '#37C074'; //Green
							} else if (value >= target - absTarget * 0.1) {
								colorCode = '#FFE349'; //Yellow
							} else {
								colorCode = '#F42F2F'; //Red
							}
						}
					}
					return colorCode;
				}

				function paintRect(color1, color2) {
					var parentElem = elem[0];
					var targetAxis = metricConfig.targetsVisible;
					var axisYParent = parentElem.getElementsByClassName('c3-axis-y')[0];
					var axisY2Parent = parentElem.getElementsByClassName('c3-axis-y2')[0];
					var axisYTopTick;
					var axisY2TopTick;
					var childTicks;
					if (axisYParent) {
						childTicks = jQuery(axisYParent).find('.tick');
						if (childTicks && childTicks.length) {
							axisYTopTick = childTicks[childTicks.length - 1];
						}
					}
					if (axisY2Parent) {
						childTicks = jQuery(axisY2Parent).find('.tick');
						if (childTicks && childTicks.length) {
							axisY2TopTick = childTicks[childTicks.length - 1];
						}
					}
					if (axisYTopTick && axisY2TopTick) {
						var targetSvg, squareY, squareY2;
						if (targetAxis === 'y') {
							targetSvg = makeSVG('rect', {
								x: scope.rectOneX,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: '#FF9B30'
							});
							squareY = makeSVG('rect', {
								x: scope.rectOneX - scope.rectSide - 2,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: color1
							});
							squareY2 = makeSVG('rect', {
								x: scope.rectTwoX,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: color2
							});
							jQuery(axisYTopTick).prepend(squareY);
							jQuery(axisY2TopTick).prepend(squareY2);
							jQuery(axisYTopTick).prepend(targetSvg);
						} else if (targetAxis === 'y2') {
							targetSvg = makeSVG('rect', {
								x: scope.rectTwoX + scope.rectSide + 2,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: '#FF9B30'
							});
							squareY = makeSVG('rect', {
								x: scope.rectOneX,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: color1
							});
							squareY2 = makeSVG('rect', {
								x: scope.rectTwoX,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: color2
							});
							jQuery(axisYTopTick).prepend(squareY);
							jQuery(axisY2TopTick).prepend(squareY2);
							jQuery(axisY2TopTick).prepend(targetSvg);
						} else {
							squareY = makeSVG('rect', {
								x: scope.rectOneX,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: color1
							});
							squareY2 = makeSVG('rect', {
								x: scope.rectTwoX,
								y: 10,
								width: scope.rectSide,
								height: scope.rectSide,
								fill: color2
							});
							jQuery(axisYTopTick).prepend(squareY);
							jQuery(axisY2TopTick).prepend(squareY2);
						}
					}
				}

				function generateChart() {
					chartData = embedded ? scopeAccessor.getChartData(chartKey, vstreamNdx) : scopeAccessor.chartData;
					actualValues = embedded ? chartData.data.results : chartData.results;
					targetValues = embedded ? chartData.data.targets : chartData.targets;
					var hasActuals = actualValues && actualValues.length > 0;
					var hasTargets = targetValues && targetValues.length > 0;
					if (!hasActuals && !hasTargets) {
						return;
					}
					currencySymbol = scopeAccessor.currencySymbol;
					metricConfig = chartData.metricConfig;
					isComboChart = metricConfig.comboChart;
					yAxisFieldLabel = $translate.instant(metricConfig.yAxisLabel);
					xAxisFieldLabel = $translate.instant(metricConfig.xAxisLabel);
					yAxisFieldLabelTwo = $translate.instant(metricConfig.yAxisLabelTwo);
					fmtService = services[metricConfig.displayType];
					fmtServiceTwo = services[metricConfig.displayTypeTwo];
					var staticTarget = embedded ? chartData.data.areaTargets : chartData.areaTargets;
					currencySymbol = embedded ? chartData.data.currencySymbol : chartData.currencySymbol;
					var projectFactoryNdx = chartData.metricConfig.projectFactoryNdx;
					if (typeof currencySymbol === 'undefined') {
						currencySymbol = scopeAccessor.currencySymbol;
					}

					var combinedData = {};
					var categories = [];
					var categoriesTwo = [];
					var dataNames = {
						'target': $translate.instant('Target')
					};

					if (isComboChart && !metricConfig.targetsVisible && !metricConfig.targetsVisible.length) {
						targetValues = [];
						dataNames = {};
					} else if (isComboChart) {
						dataNames.target = dataNames.target + ' ';
						dataNames.target += metricConfig.targetsVisible === 'y' ? yAxisFieldLabel : yAxisFieldLabelTwo;
					}

					// create mapping of targets to months
					var targetMap = {};
					var targetDateFormat = 'yyyy-M';
					function targetMonthFunction (date) {
						if (date.fiscalYear && date.fiscalMonth) {
							return date.fiscalYear + '-M' + parseInt(date.fiscalMonth);
						}
						return $filter('date')(date.date, targetDateFormat, 'UTC');
					}
					function targetWeekFunction (date) {
						if (date.fiscalYear && date.fiscalWeek) {
							return date.fiscalYear + '-W' + parseInt(date.fiscalWeek);
						}
						return $filter('date')(date.date, targetDateFormat, 'UTC');
					}

					// fallback to metricConfig.displayResolutionType for the lean project savings widget
					if (!chartData.displayResolutionType) {
						chartData.displayResolutionType = metricConfig.displayResolutionType;
					}
					// assume same targetPeriodType across sites
					var targetPeriodType = targetValues.length > 0 ? targetValues[0].targetPeriodType : 'Monthly';
					var targetDateFunction = targetMonthFunction;
					if (chartData.displayResolutionType === 'Weekly' ||
							(chartData.displayResolutionType === 'Daily' && targetPeriodType === 'Weekly')) {
						targetDateFunction = targetWeekFunction;
					}

					angular.forEach(targetValues, function (d) {
						var dateString = targetDateFunction(d);
						if (dateString) {
							targetMap[dateString] = {
								value: d.value,
								used: false
							};
						}
					});

					// add values
					angular.forEach(actualValues, function (d) {
						var date = d.date;
						if (typeof (date) === 'string') {
							date = new Date(date);
						}

						// get/init data for this date
						var dateData = {};
						var dateString = $filter('date')(date, 'yyyy-MM-dd', 'UTC');
						if (combinedData.hasOwnProperty(dateString)) {
							dateData = combinedData[dateString];
						} else {
							dateData.date = d.date;
							combinedData[dateString] = dateData;
						}

						// add target, if any, and mark target as used
						// use weekly target if available for weekly metrics, but fallback to monthly target
						// mark both as used if both exist
						var target = targetMap[targetDateFunction(d)];
						if (target) {
							target.used = true;
							dateData.target = target.value;
						}

						if (isComboChart) {
							dateData.hasBar = d.hasBar;
						}

						// add actuals
						if (d.category !== undefined) {
							dateData['category_' + d.category] = d.value;

							// make list of categories so they can be grouped
							if (categories.indexOf('category_' + d.category) === -1) {
								categories.push('category_' + d.category);
								dataNames['category_' + d.category] = d.category;
								if (d.category === null) {
									dataNames['category_null'] = yAxisFieldLabel;
								}
							}
						}

						// repeat for second metric, if combo
						if (isComboChart && d.categoryTwo !== undefined) {
							dateData['categoryTwo_' + d.categoryTwo] = d.valueTwo;

							if (categoriesTwo.indexOf('categoryTwo_' + d.categoryTwo) === -1) {
								categoriesTwo.push('categoryTwo_' + d.categoryTwo);
								dataNames['categoryTwo_' + d.categoryTwo] = d.categoryTwo;
								if (d.categoryTwo === null) {
									dataNames['categoryTwo_null'] = yAxisFieldLabelTwo;
								}
							}
						}
					});


					function getTotals(row) {
						var total = 0;
						var count = 0;

						_.forEach(row, function (value, key) {
							if (key.indexOf('category_') === 0) {
								count += 1;
								total += value;
							}
						});

						if (metricConfig.displayType === 'percentage') {
							total /= count;
						}

						return total;
					}

					var keys = _.keysIn(combinedData);
					if (keys.length > 0) {
						keys = _.sortBy(keys, function (date) {
							return new Date(date);
						});
						var lastKey = keys[keys.length - 1];

						var currentValue = getTotals(combinedData[lastKey]);
						var previousDateKey = lastKey;
						var previousValue = currentValue;
						if (keys.length > 1) {
							if (metricConfig.metricType != 'ProcurementLog') {
								previousDateKey = keys[keys.length - 2];
								previousValue = getTotals(combinedData[previousDateKey]);
							} else {					
								// cutoffDate is monday from two weeks ago, where monday is first day of week
								var twoWeeksPrior = moment(combinedData[lastKey].date).subtract(2, 'weeks');
								var deltaCutoffDate = moment(twoWeeksPrior).day(1);
								if (deltaCutoffDate.isAfter(twoWeeksPrior)) {
									// moment starts week on sunday so move back a week if moment moved forwards when setting to monday
									deltaCutoffDate.subtract(1, 'week');
								}
								// find first data after cutoff date
								for (var index in keys) {
									var dateKey = keys[index];
									var dateData = combinedData[dateKey];
									if (moment(dateData.date).isAfter(deltaCutoffDate)) {
										previousDateKey = dateKey;
										previousValue = getTotals(dateData);
										break;
									}
								}
							}
						}
						
						var deltaValue = currentValue - previousValue;
						$rootScope.$emit('updateMetricSummary', {'current': currentValue, 'delta': deltaValue, 'previousDateKey': previousDateKey, 'metricId': metricConfig.metricId, 'currencySymbol': currencySymbol});
					}

					// add unused targets. ignore unused weekly targets
					angular.forEach(targetValues, function (d) {
						if (d.value != null) {
							var targetDateString = targetDateFunction(d);
							if (targetDateString && !targetMap[targetDateString].used) {
								targetMap[targetDateString].used = true;

								var dateString = $filter('date')(d.date, 'yyyy-MM-dd', 'UTC');
								// don't overwrite data
								if (!combinedData.hasOwnProperty(dateString)) {
									combinedData[dateString] = {
										'date': d.date,
										'target': d.value
									};
								}
							}
						}
					});

					var compareCategories = function (a, b) {
						var tempA = a;
						var tempB = b;
						if (tempA === 'category_null') {
							tempA = yAxisFieldLabel;
						}
						if (tempB === 'category_null') {
							tempB = yAxisFieldLabel;
						}
						if (tempA === 'categoryTwo_null') {
							tempA = yAxisFieldLabelTwo;
						}
						if (tempB === 'categoryTwo_null') {
							tempB = yAxisFieldLabelTwo;
						}
						return tempA.toLocaleLowerCase().localeCompare(tempB.toLocaleLowerCase());
					};
					categories.sort(compareCategories);
					categoriesTwo.sort(compareCategories);

					// convert to list
					actualValues = [];
					for (var dateString in combinedData) {
						if (combinedData.hasOwnProperty(dateString)) {
							actualValues.push(combinedData[dateString]);
						}
					}

					if (scopeAccessor.chartData.trendLine) {
						trendLineList = scopeAccessor.chartData.trendLine;
						var start = trendLineList.start;
						var obj = {};
						obj.date = start.x;
						obj.trend = start.y;
						actualValues.push(obj);
						var obj2 = {};
						var end = trendLineList.end;
						obj2.date = end.x;
						obj2.trend = end.y;
						actualValues.push(obj2);
					}
					// find min/max y-axis values
					var minAxisValue = d3.min(actualValues, function (d) {
						var min = Infinity;
						if (metricConfig.chartType === 'StackedBar') {
							min = 0.0;
						}
						for (var prop in d) {
							if (d.hasOwnProperty(prop) &&
								prop.indexOf('category_') === 0) {
								if (metricConfig.chartType === 'StackedBar') {
									if (d[prop] < 0) {
										min += d[prop];
									}
								} else if (d[prop] < min) {
									min = d[prop];
								}
							}
						}
						if (d.hasOwnProperty('target') && d.target !== null && d.target < min &&
							(!isComboChart ||
								metricConfig.targetsVisible && metricConfig.targetsVisible === 'y')) {
							min = d.target;
						}
						return min;
					});
					var maxAxisValue = d3.max(actualValues, function (d) {
						var max = -Infinity;
						if (metricConfig.chartType === 'StackedBar') {
							max = 0.0;
						}
						for (var prop in d) {
							if (d.hasOwnProperty(prop) &&
								prop.indexOf('category_') === 0) {
								if (metricConfig.chartType === 'StackedBar') {
									if (d[prop] > 0) {
										max += d[prop];
									}
								} else if (d[prop] > max) {
									max = d[prop];
								}
							}
						}
						if (d.hasOwnProperty('target') && d.target !== null && d.target > max &&
							(!isComboChart ||
								metricConfig.targetsVisible && metricConfig.targetsVisible === 'y')) {
							max = d.target;
						}
						return max;
					});

					var maxAxisValueOriginal = maxAxisValue;
					if (staticTarget && staticTarget > maxAxisValue) {
						maxAxisValue = staticTarget;
					}

					var minAxisTwoValue = d3.min(actualValues, function (d) {
						var min = Infinity;
						if (metricConfig.chartTypeTwo === 'StackedBar') {
							min = 0.0;
						}
						for (var prop in d) {
							if (d.hasOwnProperty(prop) &&
								prop.indexOf('categoryTwo_') === 0) {
								if (metricConfig.chartTypeTwo === 'StackedBar') {
									if (d[prop] < 0) {
										min += d[prop];
									}
								} else if (d[prop] < min) {
									min = d[prop];
								}
							}
						}
						if (d.hasOwnProperty('target') && d.target !== null && d.target < min &&
							(!isComboChart ||
								metricConfig.targetsVisible && metricConfig.targetsVisible === 'y2')) {
							min = d.target;
						}
						return min;
					});
					var maxAxisTwoValue = d3.max(actualValues, function (d) {
						var max = -Infinity;
						if (metricConfig.chartTypeTwo === 'StackedBar') {
							max = 0.0;
						}
						for (var prop in d) {
							if (d.hasOwnProperty(prop) &&
								prop.indexOf('categoryTwo_') === 0) {
								if (metricConfig.chartTypeTwo === 'StackedBar') {
									if (d[prop] > 0) {
										max += d[prop];
									}
								} else if (d[prop] > max) {
									max = d[prop];
								}
							}
						}
						if (d.hasOwnProperty('target') && d.target !== null && d.target > max &&
							(!isComboChart ||
								metricConfig.targetsVisible && metricConfig.targetsVisible === 'y2')) {
							max = d.target;
						}
						return max;
					});
					var maxAxisTwoValueOriginal = maxAxisTwoValue;

					// pad up to 10% of the y-range, less if the padding would cross 0
					var yAxisPadding = (maxAxisValue - minAxisValue) * 0.1;
					var yAxisPaddingTwo = (maxAxisTwoValue - minAxisTwoValue) * 0.1;
					// pad by 10% of the value if max and min are the same
					// if both are zero, chart will only show 0 on y-axis
					if (yAxisPadding === 0) {
						yAxisPadding = minAxisValue * 0.1;
					}
					if (yAxisPaddingTwo === 0) {
						yAxisPaddingTwo = minAxisTwoValue * 0.1;
					}
					// don't go below zero if there are no negative values
					if (minAxisValue >= 0) {
						minAxisValue -= Math.min(yAxisPadding, minAxisValue);
					} else {
						minAxisValue -= yAxisPadding;
					}
					// don't go above zero if there are no positive values
					// subtracting a negative so it won't concat strings
					if (minAxisTwoValue >= 0) {
						minAxisTwoValue -= Math.min(yAxisPaddingTwo, minAxisTwoValue);
					} else {
						minAxisTwoValue -= yAxisPaddingTwo;
					}

					// Do not add max padding if max axis is fixed
					if (metricConfig.yAxisMaxCalcType !== 'Fixed') {
						if (maxAxisValue <= 0) {
							maxAxisValue -= -1 * Math.min(yAxisPadding, maxAxisValue * -1);
						} else {
							maxAxisValue -= -1 * yAxisPadding;
						}
						// don't go above zero if there are no positive values
						// subtracting a negative so it won't concat strings
						if (maxAxisTwoValue <= 0) {
							maxAxisTwoValue -= -1 * Math.min(yAxisPaddingTwo, maxAxisTwoValue * -1);
						} else {
							maxAxisTwoValue -= -1 * yAxisPaddingTwo;
						}
					}

					// round range endpoints
					var range = {
						'min': minAxisValue,
						'max': maxAxisValue
					};
					range = fullPageChart.roundRangeValues(range, 5, true);
					minAxisValue = range.min;
					maxAxisValue = range.max;
					range = {
						'min': minAxisTwoValue,
						'max': maxAxisTwoValue
					};
					range = fullPageChart.roundRangeValues(range, 5, true);
					minAxisTwoValue = range.min;
					maxAxisTwoValue = range.max;

					// override calculated endpoints if fixed value is set
					if (embedded || isComboChart) {
						if (metricConfig.yAxisMinCalcType &&
							metricConfig.yAxisMinCalcType === 'Fixed' &&
							metricConfig.yAxisMinFixedValue < maxAxisValueOriginal) {
							// Only set this if it doesn't hide the entire dataset
							minAxisValue = metricConfig.yAxisMinFixedValue;
						}

						if (metricConfig.yAxisMaxCalcType &&
							metricConfig.yAxisMaxCalcType === 'Fixed' &&
							maxAxisValueOriginal < metricConfig.yAxisMaxFixedValue) {
							maxAxisValue = metricConfig.yAxisMaxFixedValue;
						}
						if (metricConfig.yAxisMinCalcTypeTwo &&
							metricConfig.yAxisMinCalcTypeTwo === 'Fixed' &&
							metricConfig.yAxisMinFixedValueTwo < maxAxisTwoValueOriginal) {
							minAxisTwoValue = metricConfig.yAxisMinFixedValueTwo;
						}

						if (metricConfig.yAxisMaxCalcTypeTwo &&
							metricConfig.yAxisMaxCalcTypeTwo === 'Fixed' &&
							maxAxisTwoValueOriginal < metricConfig.yAxisMaxFixedValueTwo) {
							maxAxisTwoValue = metricConfig.yAxisMaxFixedValueTwo;
						}
					} else {
						if (scopeAccessor.metricMinAxisCalcType &&
							scopeAccessor.metricMinAxisCalcType === 'Fixed' &&
							scopeAccessor.metricMinAxisValue < maxAxisValueOriginal) {
							// Only set this if it doesn't hide the entire dataset
							minAxisValue = parseInt(scopeAccessor.metricMinAxisValue, 10);
						}

						if (scopeAccessor.metricMaxAxisCalcType &&
							scopeAccessor.metricMaxAxisCalcType === 'Fixed' &&
							maxAxisValueOriginal < scopeAccessor.metricMaxAxisValue) {
							maxAxisValue = parseInt(scopeAccessor.metricMaxAxisValue, 10);
						}
					}


					// If displayType is percentage and originalMax was not higher than 100
					// do not allow it to be over 100
					if (metricConfig.displayType === 'percentage' && maxAxisValue > 100 && maxAxisValueOriginal <= 100) {
						maxAxisValue = 100;
					}

					actualValues.sort(function (a, b) {
						return a.date - b.date;
					});
					var startTimestamp = (actualValues && actualValues.length) ? actualValues[0].date : 0;
					var endTimestamp = (actualValues && actualValues.length) ? actualValues[actualValues.length - 1].date : 0;
					// one day
					var interval = 60 * 60 * 24 * 1000;
					if (chartData.displayResolutionType === 'Weekly') {
						interval *= 7;
					} else if (chartData.displayResolutionType === 'Monthly') {
						interval *= 30;
					}
					var possiblePoints = Math.floor((endTimestamp - startTimestamp) / interval) + 1;
					var chartWidth = jQuery('#' + elem[0].id).width() - scope.paddingLt - scope.paddingRt;
					if (embedded) {
						chartWidth = jQuery('.customChart').width() - scope.paddingLt - scope.paddingRt;
					}

					var barWidth = chartWidth / possiblePoints;
					if (metricConfig.chartType === 'SeparateBar' && !isComboChart) {
						barWidth = barWidth / (categories.length + 1) * 2;
					} else if (metricConfig.chartType === 'SeparateBar' ||
						metricConfig.chartTypeTwo === 'SeparateBar') {
						barWidth = barWidth / (categories.length + categoriesTwo.length + 1) * 2;
					}
					if (isComboChart && chartTypes[metricConfig.chartType] === 'bar' &&
						chartTypes[metricConfig.chartTypeTwo] === 'bar') {
						barWidth = barWidth / (categories.length + categoriesTwo.length + 1) * 2;
						if (possiblePoints === 1) {
							barWidth = barWidth / 1.5;
						}
					}
					var idealPoints = Math.round(chartWidth/100);
					var config = {};
					config.bindto = '#' + elem[0].id;
					config.size = {
						width: print ? scope.width : undefined,
						height: widgetHeight
					};
					config.padding = {
						right: scope.paddingRt,
						left: scope.paddingLt + (currencySymbol && currencySymbol.length >= 3 ? 20: 0),
						top: scope.paddingTop,
						bottom: scope.paddingBottom
					};

					config.data = {};
					config.data.json = actualValues;
					config.data.keys = {
						x: 'date',
						value: categories
					};
					if (isComboChart) {
						config.data.keys.value = config.data.keys.value.concat(categoriesTwo);
						config.data.axes = {};
						for (var i = 0; i < categories.length; i++) {
							config.data.axes[categories[i]] = metricConfig.axis;
						}

						for (var i = 0; i < categoriesTwo.length; i++) {
							config.data.axes[categoriesTwo[i]] = metricConfig.axisTwo;
						}
					}

					if (!isComboChart || (metricConfig.targetsVisible && metricConfig.targetsVisible.length)) {
						config.data.keys.value = config.data.keys.value.concat('target');
						if (isComboChart) {
							config.data.axes.target = metricConfig.targetsVisible;
						}
					}
					config.data.order = function (t1, t2) {
						return compareCategories(t2.id, t1.id);
					};
					if (metricConfig.chartType === 'StackedBar') {
						config.data.groups = [categories];
					} else if (metricConfig.chartTypeTwo === 'StackedBar') {
						config.data.groups = [categoriesTwo];
					}

					config.data.type = chartTypes[metricConfig.chartType];
					config.data.types = {};
					if (!isComboChart || (metricConfig.targetsVisible && metricConfig.targetsVisible.length)) {
						config.data.types = {
							'target': 'line'
						};
					}
					if (isComboChart) {
						for (var i = 0; i < categories.length; i++) {
							config.data.types[categories[i]] = chartTypes[metricConfig.chartType];
						}
						for (var i = 0; i < categoriesTwo.length; i++) {
							config.data.types[categoriesTwo[i]] = chartTypes[metricConfig.chartTypeTwo];
						}
					}
					config.data.names = dataNames;
					if (scopeAccessor.chartData.trendLine) {
						config.data.keys.value.push('trend');
						config.data.types.trend = 'line';
						config.data.names.trend = $translate.instant('Trend');
					}
					config.data.color = function (color, d) {
						var colorCode = color;
						if (d === 'target' || d.id === 'target') {
							colorCode = '#FF9B30';
						} else if (d === 'trend' || d.id === 'trend') {
							colorCode = '#C12283';
						} else if (!metricConfig.isCategorizedTwo &&
							((typeof d === 'string' && d.indexOf('categoryTwo_') === 0) ||
								(d.id && d.id.indexOf('categoryTwo_') === 0 &&
									(!metricConfig.targetsVisible || metricConfig.targetsVisible !== 'y2')))) {
							colorCode = '#7cc4fa';
						} else if (!metricConfig.isCategorized &&
							(isComboChart && (typeof d === 'string' && d.indexOf('category_') === 0) ||
								(isComboChart && d.id && d.id.indexOf('category_') === 0 &&
									(!metricConfig.targetsVisible || metricConfig.targetsVisible !== 'y')))) {
							colorCode = '#005FA5';
						} else if (!metricConfig.isCategorized &&
							((typeof d === 'string' && d.indexOf('category_') === 0) ||
								(d.id && d.id.indexOf('category_') === 0 &&
									(!metricConfig.targetsVisible || metricConfig.targetsVisible === 'y')))) {
							// don't override default color for categorized metrics
							var arrayNdx = $filter('date')(d.x, 'yyyy-MM-dd', 'UTC');
							var targetValue = null;

							if (combinedData[arrayNdx]) {
								targetValue = combinedData[arrayNdx].target;
							} else {
								var targetDateKey = targetDateFunction(d);
								if (targetMap[targetDateKey]) {
									targetValue = targetMap[targetDateKey].value;
								}
							}
							if (targetValue === null || targetValue === undefined || scope.disableColorCodingVsTarget) {
								colorCode = '#005FA5';
							} else {
								colorCode = getColorCode(d.value, targetValue, colorCode, fmtService);
							}
						} else if (!metricConfig.isCategorizedTwo &&
							d.id && d.id.indexOf('categoryTwo_') === 0 &&
							(!metricConfig.targetsVisible || metricConfig.targetsVisible === 'y2')) {
							// don't override default color for categorized metrics
							var arrayNdx = $filter('date')(d.x, 'yyyy-MM-dd', 'UTC');
							var targetValue = null;

							if (combinedData[arrayNdx]) {
								targetValue = combinedData[arrayNdx].target;
							} else {
								var targetDateKey = targetDateFunction(d);
								if (targetMap[targetDateKey]) {
									targetValue = targetMap[targetDateKey].value;
								}
							}
							if (targetValue === null || targetValue === undefined || scope.disableColorCodingVsTarget) {
								colorCode = '#7cc4fa';
							} else {
								colorCode = getColorCode(d.value, targetValue, colorCode, fmtServiceTwo);
							}
						}
						return colorCode;
					};

					var xAxisDateFormat = chartData.displayResolutionType === 'Monthly' ? 'MMM yyyy' : 'mediumDate';
					config.axis = {
						x: {
							'type': 'timeseries',
							localtime: false,
							tick: {
								format: function (x) {
									return $filter('date')(x, xAxisDateFormat, 'UTC');
								},
								outer: false,
								count: possiblePoints > 5 ? 3 : possiblePoints < idealPoints ? possiblePoints : idealPoints
							}
						},
						y: {
							tick: {
								format: function (v) {
									return metricConfig.displayType == 'currency' ? fmtService.get(v, currencySymbol) : fmtService.get(v);
								},
								count: 5
							},
							min: minAxisValue,
							max: maxAxisValue,
							padding: {
								bottom: 0,
								top: 0
							}
						}
					};

					if (isComboChart) {
						config.axis.y2 = {
							tick: {
								format: function (v) {
									return metricConfig.displayTypeTwo == 'currency' ? fmtServiceTwo.get(v, currencySymbol) : fmtServiceTwo.get(v);
								},
								count: 5
							},
							min: minAxisTwoValue,
							max: maxAxisTwoValue,
							show: true,
							padding: {
								bottom: 0,
								top: 0
							}
						};
					}
					config.grid = {
						x: {
							show: false
						},
						y: {
							show: true
						}
					};
					var extraGridLines = [];
					if (chartTypes[metricConfig.chartType] === 'bar' &&
						minAxisValue < 0 && maxAxisValue > 0) {
						extraGridLines.push({
							value: 0,
							axis: 'y'
						});
					}
					if (chartTypes[metricConfig.chartTypeTwo] === 'bar' &&
						minAxisTwoValue < 0 && maxAxisTwoValue > 0) {
						extraGridLines.push({
							value: 0,
							axis: 'y2'
						});
					}
					if (staticTarget) {
						extraGridLines.push({
							value: staticTarget,
							axis: 'y',
							class: 'static-target'
						});
					}
					if (extraGridLines.length > 0) {
						config.grid.y.lines = extraGridLines;
					}
					var hideLegendIfTooManyLabels = Object.keys(config.data.names).length > 30;
					config.legend = {
						show: scope.hideLegend || print ? false : !hideLegendIfTooManyLabels
					};
					if (!isComboChart && chartTypes[metricConfig.chartType] === 'bar' &&
						!scope.disableColorCodingVsTarget) {
						config.legend.hide = 'category_null';
					}
					config.tooltip = {
						contents: tooltipFormat,
						show: print ? false : true
					};
					config.point = {
						r: 3
					};
					config.line = {
						connectNull: true
					};
					config.bar = {
						width: barWidth * 0.5
					};
					config.onrendered = function () {
						$timeout(function () {
							addStaticTargetLabel(elem, staticTarget, currencySymbol);
						}, 0);
					};
					config.data.onclick = function (d) {
						if (globalConfig.user.role !== 'Supplier' && !opened) {
							opened = true;
							var qryParams = {};
							var factoryIdList = !projectFactoryNdx ? leanFilterService.getFactoryList(): projectFactoryNdx;
							var vStreams = leanFilterService.getSelectedIds('valueStream');
							vStreams = (!vStreams || !vStreams.length || vStreams.toString() === 'LDNA_A_S') ? '' : vStreams.toString();
							qryParams.vstreams = vStreams;
							var date = Date.parse(d.x);
							var dateString = $filter('date')(date, 'yyyy-MM-dd', 'UTC');
							qryParams.dateString = dateString;
							var metricNdx = metricConfig.ndx || metricConfig.metricId;
							qryParams.currency = metricConfig.currency;
							if(!metricNdx) {
								return;
							}
							var rawResultsUrl = URLS.host + URLS.prefix + factoryIdList.toString() + '/Metric/' + metricNdx +
								'/MetricResultsNonAggregated?' + jQuery.param(qryParams);
							var rawMetricData;
							getJsonData.get(rawResultsUrl).then(function (response) {
								var row = {};
								row.factoryNdxs = factoryIdList.toString();
								row.metricNdx = metricNdx;
								row.queryParams = jQuery.param(qryParams);
								row.extraColumnCount = 0;
								row.period = $filter('date')(d.x, xAxisDateFormat, 'UTC');
								row.crossSiteName = metricConfig.crossSiteName;
								row.name = metricConfig.name;
								row.metricName = metricConfig.name;
								row.isCrossSite = factoryIdList.length > 1;
								var dataObj = actualValues[d.index];
								row.showValueAB = metricConfig.isRatio;
								if (!metricConfig.isCategorized) {
									row.actual = dataObj['category_null'];
								} else {
									row.showCategory = true;
									row.extraColumnCount++;
									row.actual = 0;
									var count = 0;
									for (var categoryName in dataObj) {
										if (dataObj.hasOwnProperty(categoryName) && categoryName.indexOf('category_') === 0) {
											count++;
											row.actual += dataObj[categoryName];
										}
									}
									if (metricConfig.displayType === 'percentage') {
										row.actual /= count;
									}
								}
								if (factoryIdList.length > 1) {
									row.showSite = true;
									row.extraColumnCount++;
								}
								row.goal = dataObj.target;
								row.metricResults = [];
								rawMetricData = response;
								var fmtService = services[metricConfig.displayType];
								var minDecimals = metricConfig.displayType === 'currency' ? 2 : 0;
								row.actualAllDecimals = (row.actual || row.actual === 0) 
									? fmtService.getWithParameters(row.actual, Math.max(numberOfDecimals(row.actual, 0, true), minDecimals), response.currencySymbol)
									: undefined;
								row.goalAllDecimals = (row.goal || row.goal === 0) 
									? fmtService.getWithParameters(row.goal, Math.max(numberOfDecimals(row.goal, 0, true), minDecimals), response.currencySymbol)
									: undefined;
								if (fmtService) {
									if (metricConfig.displayType === 'currency') {
										row.actual = fmtService.get(row.actual, response.currencySymbol);
										row.goal = fmtService.get(row.goal, response.currencySymbol);
									} else {
										row.actual = fmtService.get(row.actual);
										row.goal = fmtService.get(row.goal);
									}
								}
								if (metricConfig.comboChart) {
									// can't show goal/actual for both metrics, so show neither
									row.goal = 'Multiple Metrics';
									row.goalAllDecimals = row.goal;
									row.actual = 'Multiple Metrics';
									row.actualAllDecimals = row.actual;
								}
								if (rawMetricData && rawMetricData.results) {
									row.showValueStream = false;
									var metricName = null;
									angular.forEach(rawMetricData.results, function (result) {
										var tmp = {};
										tmp.unformattedValue = result.value;
										tmp.unformattedValueA = result.valueA;
										tmp.unformattedValueB = result.valueB;
										if (metricName == null) {
											metricName = result.name;
										} else if (!row.showMetricName) {
											if (result.name !== metricName) {
												row.showMetricName = true;
												row.extraColumnCount++;
											}
										}
										// format the value
										fmtService = services[result.displayType];
										if (fmtService) {
											formatValue(response, result, fmtService, 'value', 'rawValue');
											formatValue(response, result, fmtService, 'valueA', 'rawValueA');
											formatValue(response, result, fmtService, 'valueB', 'rawValueB');
										}
										tmp.actualDate = $filter('date')(result.currentDate, 'MMM dd', 'UTC');
										tmp.date = tmp.actualDate;
										tmp.value = result.value;
										tmp.valueA = result.valueA;
										tmp.valueB = result.valueB;
										tmp.metricName = result.name;
										tmp.category = result.category;
										tmp.rawValue = result.rawValue;
										tmp.rawValueA = result.rawValueA;
										tmp.rawValueB = result.rawValueB;
										tmp.valueStream = result.valueStream;
										tmp.factoryName = result.factoryName;
										tmp.leanDirFactoryNdx = result.leanDirFactoryNdx;
										tmp.ndx = result.ndx;
										tmp.comment = result.comment;
										tmp.commentNdx = result.commentNdx;
										if (result.isCategorized) {
											tmp.category = result.category;
										}
										if (!row.showValueStream) {
											// could be UndefinedValueStream or UndefinedValuestream
											if (result.valueStream && result.valueStream.toUpperCase() !== 'UNDEFINEDVALUESTREAM') {
												row.showValueStream = true;
												row.extraColumnCount++;
											}
										}
										row.metricResults.push(tmp);
									});
									angular.forEach(rawMetricData.metricInactiveInterval, function (inactiveInterval) {
										var tmp = {};
										tmp.unformattedValue = 'N/A';
										var resultDate = new Date(inactiveInterval.endTimestamp);
										tmp.actualDate = $filter('date')(resultDate, 'MMM dd', 'UTC');
										tmp.date = tmp.actualDate;
										tmp.value = 'N/A';
										tmp.valueA = 'N/A';
										tmp.valueB = 'N/A';
										tmp.metricName = inactiveInterval.name;
										tmp.rawValue = tmp.value;
										tmp.rawValueA= tmp.valueA;
										tmp.rawValueB = tmp.valueB;
										tmp.valueStream = inactiveInterval.valueStream;
										tmp.factoryName = inactiveInterval.factoryName;
										tmp.leanDirFactoryNdx = inactiveInterval.leanDirFactoryNdx;
										tmp.ndx = null;
										tmp.comment = null;
										tmp.commentNdx = null;
										tmp.isInactive =  true;
										row.metricResults.push(tmp);
									});
								}
								var instance;
								$timeout(function () {
									instance = slideInModalService.openModal({
										templateUrl: '/application/f/dashboard/metric-comments-slide-in.html',
										windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html',
										controller: 'metricCommentSlideIn as metricCommentSlideInCtrl',
										resolve: {
											'row': function () {
												return row;
											}
										}
									});
									instance.result.then(function () {
										opened = false;
									});
									instance.result.catch(function() {
										jQuery('.inlineEditDiv').unbind();
										jQuery('.inlineEditDiv').remove();
										opened = false;
									});
								}, 0);

							}, function (e) {
								rawMetricData = undefined;
								opened = false;
							});
						}
					};
					scope.tooManyCategories = Object.keys(config.data.names).length > 100;
					if (!scope.tooManyCategories) {
						chart = c3.generate(config);
						chartService.addChartForPrint(chart);
					}
				}
				var generateListener = scope.$on(eventName, function () {
					generateChart();
					if (isComboChart) {
						paintRect('#005FA5', '#7cc4fa');
					}
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (generateListener) {
						generateListener();
					}
				});
			}
		};

		function formatValue(response, result, fmtService, fieldName, rawFieldName) {
			if (typeof result[fieldName] !== undefined && result[fieldName] !== null) {
				var decimals = metricRoundingService.getDecimals(result);
				if (result.displayType === 'currency') {
					decimals = Math.max(decimals, 2);
					result[rawFieldName] = fmtService.getWithParametersNegativeSign(result[fieldName], decimals, response.currencySymbol);
					result[fieldName] = fmtService.get(result[fieldName], response.currencySymbol);
				} else if (result.displayType === 'percentage') {
					result[rawFieldName] = fmtService.getWithParameters(result[fieldName], decimals);
					result[fieldName] = fmtService.get(result[fieldName]);
				} else {
					result[rawFieldName] = fmtService.getWithParameters(result[fieldName], decimals, true);
					result[fieldName] = fmtService.get(result[fieldName]);
				}
			}
		}

		function makeSVG(tag, attrs) {
			var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
			for (var k in attrs) {
				if (attrs.hasOwnProperty(k)) {
					el.setAttribute(k, attrs[k]);
				}
			}
			return el;
		}

		function addStaticTargetLabel(elem, staticTarget, currencySymbol) {
			if (!jQuery('.addedLabel') || !jQuery('.addedLabel').length) {
				var parentElem = elem[0];
				var staticTargetParent = parentElem.getElementsByClassName('static-target')[0];
				var yAxisWidth = 0;
				var chartWidth = 0;
				var yAxisObj = elem.find('.c3-axis-y')[0];
				var chartObj = elem.find('.c3-grid')[0];
				if (yAxisObj) {
					yAxisWidth = elem.find('.c3-axis-y')[0].getBoundingClientRect().width;
				}
				if (chartObj) {
					chartWidth = elem.find('.c3-grid')[0].getBoundingClientRect().width;
				}
				var stretchLineElem;
				var staticTargetLineElem;
				if (staticTargetParent && chartObj) {
					var fyLine = staticTargetParent.getElementsByTagName('line');
					if (fyLine && fyLine.length === 1) {
						staticTargetLineElem = fyLine[0];
					}
				}
				if (staticTargetLineElem && chartObj) {
					var label = makeSVG('text', {
						x: yAxisWidth + chartWidth,
						y: parseInt(jQuery(staticTargetLineElem).attr('y2')),
						fill: '#1CAF5E',
						style: 'font-size:12px',
						class: 'addedLabel'
					});
					var label2 = makeSVG('text', {
						x: yAxisWidth + chartWidth,
						y: parseInt(jQuery(staticTargetLineElem).attr('y2')) + 16,
						fill: '#1CAF5E',
						style: 'font-size:12px',
						class: 'addedLabel'
					});
					var label3 = makeSVG('text', {
						x: yAxisWidth + chartWidth,
						y: parseInt(jQuery(staticTargetLineElem).attr('y2')) + 32,
						fill: '#1CAF5E',
						style: 'font-size:12px',
						class: 'addedLabel'
					});
					label.textContent = $translate.instant('PROJECT_AREA');
					label2.textContent = 'Target:';
					label3.textContent = services.currency.get(staticTarget, currencySymbol);
					jQuery(parentElem.getElementsByTagName('svg')[0]).append(label);
					jQuery(parentElem.getElementsByTagName('svg')[0]).append(label2);
					jQuery(parentElem.getElementsByTagName('svg')[0]).append(label3);
				}
			}
		}
	}
})();
